import { render, staticRenderFns } from "./AddBusinessUnit.vue?vue&type=template&id=3537ffff&scoped=true&"
import script from "./AddBusinessUnit.vue?vue&type=script&lang=js&"
export * from "./AddBusinessUnit.vue?vue&type=script&lang=js&"
import style0 from "./AddBusinessUnit.vue?vue&type=style&index=0&id=3537ffff&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3537ffff",
  null
  
)

export default component.exports